const state = {
    mhdItems: [],
    mhdInventoryDrawerState: false
}

export default state
